export const isEmpty = (value: any): boolean => {
  if (value == null) {
    return true
  }
  if (Array.isArray(value)) {
    return value.length === 0
  }
  if (typeof value === 'object') {
    return Object.keys(value).length === 0
  }
  if (typeof value === 'string') {
    return value.trim().length === 0
  }
  return false
}

export const isNil = (value: any): boolean => {
  if (value == null) {
    return true
  }
  if (value == Number.isNaN(value) && !Array.isArray(value)) {
    return true
  }
  if (value == undefined) {
    return true
  }
  return false
}

export const isEqual = (value: any, other: any): boolean => {
  if (value === other) {
    return true
  }
  if (value == null || other == null) {
    return false
  }
  if (typeof value !== typeof other) {
    return false
  }
  if (typeof value !== 'object') {
    return false
  }
  if (Array.isArray(value) !== Array.isArray(other)) {
    return false
  }
  if (Array.isArray(value)) {
    if (value.length !== other.length) {
      return false
    }
    for (let i = 0; i < value.length; i++) {
      if (!isEqual(value[i], other[i])) {
        return false
      }
    }
    return true
  }
  const valueKeys = Object.keys(value)
  const otherKeys = Object.keys(other)
  if (valueKeys.length !== otherKeys.length) {
    return false
  }
  for (const key of valueKeys) {
    if (!isEqual(value[key], other[key])) {
      return false
    }
  }
  return true
}

export const throttle = (callback: () => any, limit: number): any => {
  let waiting = false
  return function () {
    if (!waiting) {
      callback()
      waiting = true
      setTimeout(function () {
        waiting = false
      }, limit)
    }
  }
}

export const debounce = (callback: (...args: any[]) => any, delay: number, { leading = false } = {}): any => {
  let timerId: NodeJS.Timeout

  return (...args: any): any => {
    if (!timerId && leading) {
      callback(...args)
    }
    clearTimeout(timerId)

    timerId = setTimeout(() => callback(...args), delay)
  }
}

export const isString = (str: any): boolean => {
  if (str != null && typeof str.valueOf() === 'string') {
    return true
  }
  return false
}

export const isError = (err: any): boolean => err instanceof Error

export const last = (array: any[]): any => array[array.length - 1]

// Convert period strings like PT1H, PT1D2H, PT32.24S to minutes
export const periodToMinutes = (period: string): number => {
  const regex = /P(?:(\d+)D)?T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?/
  const match = period.match(regex)
  if (!match) {
    throw new Error(`Invalid period: ${period}`)
  }
  const [, days, hours, minutes, seconds] = match
  return (
    (Number(days) || 0) * 24 * 60 + (Number(hours) || 0) * 60 + (Number(minutes) || 0) + (Number(seconds) || 0) / 60
  )
}

export const isValidOwnerName = (ownerName: string): boolean => {
  return /^[a-zA-Z0-9_-]+$/.test(ownerName)
}

export const isValidPublicProjectName = (publicProjectName: string): boolean => {
  return /^[a-zA-Z0-9_-]+$/.test(publicProjectName)
}

export const isMobileDevice = (userAgent: string): boolean => {
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(userAgent)
}
